function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.295 1.875L14.25 9.83M6.295 17.785L14.25 9.83",
    stroke: props.color || 'black',
    strokeWidth: 3,
    strokeLinecap: "round"
  }));
}
export default SvgRight;